(function() {
    'use strict';

    angular
        .module('app')
        .controller('applicationFormTypeSelectorController', applicationFormTypeSelectorController);

    function applicationFormTypeSelectorController($q, $rootScope, $scope, $uibModalInstance, trainingInnerService) {
        var vm = this;
        vm.cancel = cancel;
        vm.TypeSelected = TypeSelected;

        onInit();

        function onInit() {
            var promiseList = [
                trainingInnerService.getExternaltype(), // 證照狀態
            ];
            return $q.all(promiseList)
                .then(function(receiveData) {
                    //console.log(receiveData);
                    //vm.type = receiveData[0];
                    vm.type = _.filter(receiveData[0], function(o) {
                        return o.id !== -1;
                    });
                });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }



        function TypeSelected(data) {
            //console.log('TypeSelected:',data);
            $uibModalInstance.close(data);
        }

    }
})();